import { toEnPageSlug, translatePagePath } from "../utils/SlugUtils.js";

export default class GeoNerdNavigation {
	constructor() {
		this.initNavigation();
	}

	initNavigation() {
		const isEnglish = window.location.pathname.startsWith('/en');
		const pathElements = window.location.pathname.split('/');
		let currentPath = pathElements.pop();

		if (!currentPath || currentPath === "" || currentPath === "en") {
			currentPath = "/";
		} else {
			currentPath = "/" + currentPath;
		}

		// Update all internal links if in English mode.
		// Le build préfixe déjà ces liens (tâche gulp `injectI18n`) pour qu'ils
		// existent dans le HTML servi ; ce passage ne rattrape donc que le markup
		// injecté par JS. Il doit rester idempotent et produire la même chaîne :
		// `/en/` avec son slash final (`/en` répond 301).
		if (isEnglish) {
			document.querySelectorAll('a[href^="/"]').forEach(link => {
				const href = link.getAttribute('href');
				// Test explicite plutôt que startsWith('/en'), qui laisserait
				// passer un futur slug commençant par "en" (ex. /entrainement).
				if (href === '/en/' || href === '/en' || href.startsWith('/en/')) return;
				const translated = href === '/' ? '/' : translatePagePath(href, toEnPageSlug);
				link.setAttribute('href', href === '/' ? '/en/' : '/en' + translated);
			});
		}

		// Lien de menu actif. On part des LIENS (`a[href]`) et non de `.nav-link` :
		// depuis le menu à deux niveaux, les entrées qui déplient un sous-menu sont
		// des <button> sans href, et un mode de jeu doit aussi marquer actives les
		// entrées qui le contiennent (« Jeux », puis le jeu).
		const cleanCurrent = isEnglish ? window.location.pathname.replace(/^\/en/, '') || '/' : window.location.pathname;
		document.querySelectorAll(".site-header .active").forEach(el => el.classList.remove("active"));
		document.querySelectorAll('.site-header a[href^="/"]').forEach(link => {
			const href = link.getAttribute("href");
			const cleanHref = isEnglish ? href.replace(/^\/en/, '') || '/' : href;
			if (cleanHref !== cleanCurrent) return;

			link.classList.add("active");
			link.closest(".submenu-item")?.querySelector(":scope > .submenu-link")?.classList.add("active");
			link.closest(".nav-item")?.querySelector(":scope > .nav-link")?.classList.add("active");
		});

		// Hide header only on map pages (full-screen map needs the space). US States
		// List stays in normal flow (no map, same as Country Nerd).
		if (currentPath.includes("map-nerd") || currentPath.includes("us-states-classic") ||
			currentPath.includes("us-states-hard") || currentPath === "/training-map" ||
			currentPath === "/training-map-us") {
			document.body.classList.add("is-gaming");
		} else {
			document.body.classList.remove("is-gaming");
		}
	}
}
